// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"6a8ca60138baad4627d0","966":"19172fc9c32a2cbd528a"}[chunkId] + ".js";
};